export default __webpack_public_path__ + "static/media/spark_66.5aaf1d0f.png";